import React from 'react';
import {connect} from 'react-redux';
import {List} from 'immutable';

import League from './League.jsx';

import {sportSortFunc, leagueSortFunc} from 'rendering-commons/Sorting';

function renderLeague(league, props) {
    const leagueId = league.get('id');
    return (<League key={leagueId} id={leagueId} {...props} />);
}

function filterMatches(matches, date, filter) {
    if (filter === null || filter === undefined) {
        return matches;
    }

    return matches.filter(m => m.get('startDate') <= date);
}

function sortLeagues(sports, leagues) {
    let result = new List();
    if (sports) {
        sports = sports.sort(sportSortFunc);

        sports.forEach(sport => {
            const sportLeagues = sport
                .get('leagues')
                .map((l) => leagues.get(l))
                .sort(leagueSortFunc);

            result = result.concat(sportLeagues);
        });
    }

    return result;
}

class Leagues extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        sports: React.PropTypes.object.isRequired,
        leagues: React.PropTypes.object.isRequired,
        matches: React.PropTypes.object.isRequired,
        filter: React.PropTypes.number,
        gridSelection: React.PropTypes.object.isRequired,
        selectionToggleMatchAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    renderLeagues(leagues, leagueProps) {
        const {currentPage, perPage, matches, filter} = this.props;

        const start = (currentPage - 1) * perPage;
        const end = currentPage * perPage;

        let matchCounter = 0;
        let dateFilter;

        const leagueRenderElements = [];

        if (filter === null) {
            dateFilter = null;
        } else {
            const date = new Date();

            dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
        }

        if (currentPage && perPage) {
            leagues.map(function(league) {
                const leagueMatches = matches.filter(match => match.get('leagueId') === league.get('id'));
                let filteredMatches = [];
                if (leagueMatches.size > 0) {
                    filteredMatches = filterMatches(leagueMatches, dateFilter, filter);
                }
                matchCounter += filteredMatches.size;

                if (filteredMatches.size > perPage) {
                    if (Math.floor(start / perPage) !== Math.floor(filteredMatches.size / perPage)) {
                        leagueRenderElements.push(renderLeague(league, leagueProps));
                    }
                } else {
                    if (start <= matchCounter - filteredMatches.size && matchCounter - filteredMatches.size <= end) {
                        leagueRenderElements.push(renderLeague(league, leagueProps));
                    }
                }
            });
        } else {
            leagues.map(function(league) {
                leagueRenderElements.push(renderLeague(league, leagueProps));
            });
        }

        return leagueRenderElements;
    }

    render() {
        const {
            section,
            gridLocalization,
            sports,
            leagues,
            filter,
            matchId,
            gridSelection,
            selectionToggleMatchAction
            } = this.props;

        const sortedLeagues = sortLeagues(sports, leagues);

        const leagueProps = {
            section,
            gridLocalization,
            filter,
            matchId,
            gridSelection,
            selectionToggleMatchAction
        };

        return (
            <div>
                {this.renderLeagues(sortedLeagues, leagueProps)}
            </div>
        );
    }
}

function select(state, props) {
    const {section} = props;

    const sports = state.application.get(section).get('sports');
    const leagues = state.application.get(section).get('leagues');
    const matches = state.application.get(section).get('matches');

    return {
        ...props,
        sports,
        leagues,
        matches
    };
}

export default connect(select)(Leagues);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/Leagues.jsx